import * as React from "react";

import { UnitId } from "../Unit/UnitId/UnitId";
import { isChildOfType } from "../../TypingUtils";
import { isNotNullOrUndefined } from "../../../../../Common/TypingUtils";
import { menuItemInfosKey } from "../../Internals/ViewModeSelector/ViewModes";

import { UnitItemContainer } from "./UnitItemContainer";
import { MenuItemChildInstanceContainer } from "./Internals/MultipleUnit/MenuItemChildInstance/MenuItemChildInstanceContainer";

export function getChildUnitIds(props: { children?: React.ReactNode }): UnitId[] {
    if (props.children != undefined) {
        return React.Children.toArray(props.children)
            .map(child => {
                if (isChildOfType(child, UnitItemContainer) || isChildOfType(child, MenuItemChildInstanceContainer)) {
                    return [child.props.id].concat(getChildUnitIds(child.props));
                }
                return undefined;
            })
            .flat()
            .filter(isNotNullOrUndefined);
    }
    return [];
}

export function getLabel(label: undefined | string): string {
    return label == undefined || label === "" || /^Экземпляр\s+\d+$/.test(label) ? `Экземпляр` : label;
}

export function getLabelForModal(label: undefined | string, index: number): string {
    return label == undefined || label === "" || /^Экземпляр\s+\d+$/.test(label) ? `Экземпляр ${index + 1}` : label;
}

export function getMenuItemInfosKey(
    pageId: string,
    fufDraftId?: string,
    instance?: string,
    instances?: string[] | readonly string[],
    pageName?: string
): string {
    return `${menuItemInfosKey}_fufDraftId=${fufDraftId}_pageId=${pageId}${instance ? `_instance=${instance}` : ""}${
        instances ? `_instances=${instances.join("-")}` : ""
    }${instances ? `_pageName=${pageName}` : ""}`;
}

export function getRemoveLabelForChangeSet(unitName?: string): string {
    return unitName ? `Удален ${unitName}` : "Удаление раздела";
}
